import { TFunction } from 'i18next'
import { z, ZodType } from 'zod'

import { BankLine } from '@modules-deprecated/bankReconciliation/types'

export interface CreateManualPaymentForm {
  description: string
  receiptNumber: string
  accountId: string
  vatRateId: string | null
}

export type CreateManualPaymentFormSchema = ZodType<CreateManualPaymentForm>

export const getValidationSchema = (t: TFunction): CreateManualPaymentFormSchema =>
  z.object({
    description: z.string().trim().min(1, t('required_field')),
    receiptNumber: z.string().trim().min(1, t('required_field')),
    accountId: z.string().trim().min(1, t('required_field')),
    vatRateId: z.string().trim().nullable(),
  })

export const getDefaultValues = (
  transaction: BankLine | null,
  nextVoucherNumber?: number,
): CreateManualPaymentForm => ({
  description: transaction?.description ?? '',
  receiptNumber: nextVoucherNumber?.toString() ?? '',
  accountId: '',
  vatRateId: null,
})
